import React, {useEffect, useState} from "react";
import { Form } from 'react-final-form'
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {setPage} from "../actions/PageActions";
import scrollToFirstError from "../helpers/ScrollToFirstErrorHelper";
import { animateScroll } from 'react-scroll';
import {getFormValues, saveFormValues} from "../helpers/formStorage";

function Wizard({initialValues, children, onSubmit, mutators}) {
    const dispatch = useDispatch();
    const page = useSelector(state => state.page.page);
    const [values, setValues] = useState(() => {
        const saved = getFormValues();
        return saved ? {...initialValues, ...saved} : initialValues;
    });
    const activePage = React.Children.toArray(children)[page];

    useEffect(() => {
        animateScroll.scrollTo(0);
    }, [page])

    const next = values => {
        saveFormValues(values);
        dispatch(setPage(Math.min(page + 1, children.length - 1)));
        setValues(values);
    }
    // const previous = () => dispatch(setPage(Math.max(page - 1, 0)));
    const isLastPage = page === React.Children.count(children) - 1;

    const validate = values => activePage.props.validate ? activePage.props.validate(values) : {};

    const handleSubmit = async values => {
        if (activePage.props.onBeforeSubmit) {
            const errors = await activePage.props.onBeforeSubmit(values);
            if (errors) {
                return errors;
            }
        }

        if (isLastPage) {
            return onSubmit(values);
        } else {
            next(values);
        }
    }

    return <Form
        initialValues={values}
        onSubmit={handleSubmit}
        validate={validate}
        mutators={mutators}
        decorators={[scrollToFirstError]}
    >
        {({handleSubmit, submitting, values, submitError}) => (
            <form onSubmit={handleSubmit} id="order-wizard-form">
                {activePage}
            </form>
        )}
    </Form>
}

Wizard.Page = ({children}) => children;

Wizard.propTypes = {
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    mutators: PropTypes.object,
}

export default Wizard;
